/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { setupAxios } from "./infofleet";
import store, { persistor } from "./app/store/store";
import App from "./App";
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./infofleet/_assets/plugins/line-awesome/css/line-awesome.css";
import "./infofleet/_assets/plugins/flaticon/flaticon.css";
import "./infofleet/_assets/plugins/flaticon2/flaticon.css";
import { createRoot } from 'react-dom/client'; // ✅ Required for React 18+
import axios from "axios";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;


/**
 * Inject Infofleet interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios, store);

// ReactDOM.render(
//   <App store={store} persistor={persistor} basename={PUBLIC_URL} />,
//   document.getElementById("root")
// );
/** Added By Karthika on 08/05/2025 16 to 19 migration */

const rootElement = document.getElementById("root");
const root = createRoot(rootElement); // ✅ This is correct
root.render(
  <App store={store} persistor={persistor} basename={PUBLIC_URL} />
);